/**
 * 画像拡大 (luminous ベース) - v1 テンプレート専用 / v2 では未使用
 *
 * v2 テンプレート (isNewTemplateV2() == true) では assets/js/image-popup.js
 * (vanilla 独自実装) に置き換え済みで、 lib/assets.php の assets_v2() からは
 * enqueue されない。 旧 v1 テンプレート稼働サイトの後方互換のためのみ残置。
 */
import Luminous from "../vendor/luminous/Luminous.js";
import LuminousGallery from "../vendor/luminous/LuminousGallery.js";
/*!
 * Luminous v2.3.5
 * Copyright 2015-2021, Zebrafish Labs
 * Licensed under BSD-2 (https://github.com/imgix/luminous/blob/main/LICENSE.md)
 */

(function () {
    "use strict";

    function attachLuminous(el) {
        // 通常画像
        const images = el.querySelectorAll(
            '.image-popup, [class^="wp-image-"], [class*=" wp-image-"], ' +
            '.gallery-item img' // ギャラリー画像
        );
        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            const is_class_popup = !image.parentNode.classList.contains("img-popup"); // すでにpopup要素のもの
            const is_exclusion = !image.classList.contains("exclusion-popup"); // 除外クラス
            const is_lower_a = image.parentNode.tagName.toLowerCase() === "a";
            const is_align = imageAlignCheck(image);
            if (is_lower_a && is_exclusion && is_class_popup) {
                const aTag = image.parentNode;
                const is_same_url = urlDiff(aTag.href, image.src);
                if (is_same_url) {
                    aTag.classList.add("img-popup");
                    aTag.href = replaceSrc(image.src);

                    if (is_align !== false) {
                        const divTag = document.createElement("div");
                        divTag.classList.add(is_align);
                        aTag.parentNode.insertBefore(divTag, aTag);
                        divTag.appendChild(aTag);
                    }
                }
            } else {
                // img要素単体
                // 現状はimage-popupが指定されているもののみとしています
                const is_class_image_popup = image.classList.contains("image-popup");
                if (is_class_image_popup) {
                    const aTag = document.createElement("a");

                    aTag.href = replaceSrc(image.src);
                    aTag.classList.add("img-popup");
                    image.parentNode.insertBefore(aTag, image);
                    aTag.appendChild(image);

                    if (is_align !== false) {
                        const divTag = document.createElement("div");
                        divTag.classList.add(is_align);
                        aTag.parentNode.insertBefore(divTag, aTag);
                        divTag.appendChild(aTag);
                    }
                }
            }
        }
    }

    // IntersectionObserver スクロール時に要素変換
    // 大量の画像がある場合などに使用するとロードが速い
    function onIntersection(entries, observer) {
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const lazyImage = entry.target;
            const is_class_popup =
                !lazyImage.parentNode.classList.contains("img-popup"); // すでにpopup要素のもの
            const is_exclusion = !lazyImage.classList.contains("exclusion-popup"); // 除外クラス
            const is_class_lazy_img = lazyImage.classList.contains("gp-lazy-img");
            if (is_class_lazy_img) {
                // data-src,data-original-srcから画像の指定をする新パターン
                // 元画像のsrcに"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="を指定する
                const src = lazyImage.dataset.src;
                const original_src = lazyImage.dataset.originalSrc;
                if (entry.isIntersecting && src && is_class_popup && is_exclusion) {
                    try {
                        lazyImage.src = src;
                        const aTag = document.createElement("a");
                        aTag.href = original_src;
                        aTag.classList.add("gp-lazy-container");
                        aTag.classList.add("img-popup");
                        lazyImage.parentNode.insertBefore(aTag, lazyImage);
                        aTag.appendChild(lazyImage);
                        observer.unobserve(lazyImage);

                        delete lazyImage.dataset.originalSrc;
                        delete lazyImage.dataset.src;
                        new Luminous(aTag);
                    } catch (error) {
                        console.error(`Error loading image: ${error}`);
                    }
                }
            }
        }
    }

    // URLの比較
    function urlDiff(url_1, url_2) {
        const arr_1 = url_1.split("/");
        const arr_2 = url_2.split("/");
        const result = arr_2.filter((x) => !arr_1.includes(x));
        return result.length === 1 || result.length === 0 ? true : false;
    }

    // URLのリサイズ除去
    function replaceSrc(url) {
        url = url.replace(/-\d+x\d+\./, ".");
        url = url.replace(/resize=.*&/, "");
        url = url.replace(/w=[0-9]+/, "");
        url = url.replace(/h=[0-9]+/, "");
        url = url.replace(/width=[0-9]+/, "");
        url = url.replace(/height=[0-9]+/, "");
        return url;
    }

    // align調整
    function imageAlignCheck(image) {
        let image_class = image.classList;
        let align_left = image_class.contains("alignleft");
        let align_center = image_class.contains("aligncenter");
        let align_right = image_class.contains("alignright");

        if (align_left) {
            return "text-left";
        } else if (align_center) {
            return "text-center";
        } else if (align_right) {
            return "text-right";
        } else {
            return false;
        }
    }

    const attachObserver = (el) => {
        // Observerの設定を先に行う
        const lazyImages = el.querySelectorAll(".gp-lazy-img");
        const observer_options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };

        const observer = new IntersectionObserver(onIntersection, observer_options);

        for (let i = 0; i < lazyImages.length; i++) {
            observer.observe(lazyImages[i]);
        }

        // 少し遅延させてLuminousGalleryの初期化を行う
        setTimeout(() => {
            const popup = el.querySelectorAll(".img-popup");
            new LuminousGallery(popup);
        }, 100);
    };

    //document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        //console.log("load");
        attachLuminous(document);
        attachObserver(document);
    });


    document.addEventListener("customDOMContentLoaded", function (event) {
        const modalWindow = event.detail.modalWindow;
        attachLuminous(modalWindow);
        attachObserver(modalWindow);
    });
})();
